import { getRemotes } from './contract/api'

const getenvironment = async () => {
  const r = await getRemotes()

  window.MAP_URL = r.MAP_URL
  window.APP_FRAME_URL = r.APP_FRAME_URL
  window.STYLE_URL = r.STYLE_URL

  import('./bootstrap')
}

getenvironment()
